// extracted by mini-css-extract-plugin
export var actionText = "_pe-4";
export var container = "_pe-0";
export var leftSection = "_pe-1";
export var rightSection = "_pe-2";
export var settingsButton = "_pe-6";
export var settingsIcon = "_pe-7";
export var shortcut = "_pe-5";
export var shortcutGroup = "_pe-3";